import { Problem } from "ketting"
import { RxMiddleware } from "modules/common/RxMiddleware"
import { Uri } from "modules/common/types"
import contactsSaga from "modules/contacts/sagas"
import {
    FETCH_CONTACT,
    FETCH_CONTACT_ERROR,
    FETCH_CONTACT_OK,
    IContactData,
    IContactRelations,
    UPDATE_CONTACT,
    UPDATE_CONTACT_ERROR,
    UPDATE_CONTACT_OK,
} from "modules/contacts/types"
import { createCustomAction } from "typesafe-actions"
import { SagaRegistry } from "utils/SagaRegistry"
import * as actions from "./actions"

export const fetchContact = createCustomAction(FETCH_CONTACT, (uri: Uri) => ({
    payload: { uri },
}))

export const fetchContactOk = createCustomAction(
    FETCH_CONTACT_OK,
    (data: IContactData, relations: IContactRelations, uri: Uri) => ({
        meta: { uri },
        payload: { data, relations },
    })
)

export const fetchContactError = createCustomAction(
    FETCH_CONTACT_ERROR,
    (error: Problem, uri: Uri) => ({ payload: error, meta: { uri } })
)

export const updateContact = createCustomAction(
    UPDATE_CONTACT,
    (data: Partial<IContactData>, uri: Uri) => ({
        payload: { data, uri },
    })
)

export const updateContactOk = createCustomAction(
    UPDATE_CONTACT_OK,
    (
        data: IContactData,
        relations: IContactRelations,
        updateData: Partial<IContactData>,
        uri: Uri
    ) => ({
        meta: { uri, data: updateData },
        payload: { data, relations },
    })
)

export const updateContactError = createCustomAction(
    UPDATE_CONTACT_ERROR,
    (e: Problem, data: IContactData, uri: Uri) => ({
        meta: { uri, data },
        payload: e,
    })
)

RxMiddleware.addActions(actions)
SagaRegistry.register(contactsSaga)
